import React, { useState, useEffect } from "react";
import "./Countdown.css";
import weddingBg from "../assets/wedding-bg.jpg";
import { Link } from 'react-router-dom';
export default function Countdown({ maxWidth = "100%" }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [ratio, setRatio] = useState(1);

  function calculateTimeLeft() {
    const weddingDate = new Date("2026-06-18T00:00:00");
    const diff = weddingDate - new Date();
    if (diff <= 0) return null;

    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  }

  useEffect(() => {
    const img = new Image();
    img.src = weddingBg;
    img.onload = () => {
      setRatio(img.height / img.width);
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!timeLeft) return null;

  return (
    <div className="countdown-wrapper" style={{ maxWidth }}>
      <div
        className="countdown-box"
        style={{
          backgroundImage: `url(${weddingBg})`,
          aspectRatio: `${1 / ratio}`,
        }}
      >

        <p1>Dylan &</p1>
        <p1>Natascha</p1>
        <p2>Invite you to our wedding.</p2>
        <div className="timer">
          <div className="timeUnit">
            <text className="time">{timeLeft.days}</text>
            <text className="label">Days</text>
          </div>
          <div className="timeUnit">
            <text className="time">{timeLeft.hours}</text>
            <text className="label">Hours</text>
          </div>
          <div className="timeUnit">
            <text className="time">{timeLeft.minutes}</text>
            <text className="label">Minutes</text>
          </div>
          <div className="timeUnit">
            <text className="time">{timeLeft.seconds}</text>
            <text className="label">Seconds</text>
          </div>
        </div>
        <form className="btn-box">
          <Link to="/register" className="btn"> RSVP </Link>
        </form>
      </div>

    </div>
  );
}
